<div class="attr-card" (click)="onClick()">
  <app-attraction-image class="attr-card-image" [url]="imageUrl" [alt]="attraction.title || ''"></app-attraction-image>

  <div class="attr-card-info">
    <h3 class="attr-card-title">{{ attraction.title }}</h3>

    <app-attraction-rating-row class="attr-card-rating"
      [rating]="attraction.rating" [reviewCount]="attraction.review_count" [compact]="true">
    </app-attraction-rating-row>

    <div class="attr-card-flags" *ngIf="hasFlag(FLAG_FREE_CANCELLATION) || hasFlag(FLAG_LIKELY_TO_SELL_OUT)">
      <span class="attr-chip" *ngIf="hasFlag(FLAG_FREE_CANCELLATION)">{{ 'attractions.freeCancellation' | translate }}</span>
      <span class="attr-chip" *ngIf="hasFlag(FLAG_LIKELY_TO_SELL_OUT)">{{ 'attractions.likelySellOut' | translate }}</span>
    </div>

    <div class="attr-card-price" *ngIf="price">{{ 'attractions.fromPrice' | translate:{ price: price } }}</div>
  </div>
</div>
